import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'notBookableHeader', standalone: true, pure: true })
export class NotBookableHeaderPipe implements PipeTransform {
  transform(text: string | undefined, minRateToBookWithPro: number | null): string {
    if (text?.includes('completely booked')) {return 'Fully Booked';}
    if (minRateToBookWithPro) {return 'Raise Rates to Book';}
    return 'No Times Available';
  }
}
